<template>
  <div class="iosmembe">
    <p class="title">会员订阅服务条款</p>
    <div class="block">
      <p class="common-p">欢迎您使用会员订阅服务！</p>
      <p class="common-p">本协议是您为使用广州心与潮信息科技有限公司（简称：心潮科技）心潮会员订阅服务（以下简称 “会员订阅服务”），您应当阅读并遵守《会员订阅服务条款》（以下简称“本条款”）。</p>
      <p class="common-p">
        本条款为<a href="https://www.heartide.com/cosleep/help/doc#/xcwarn">《服务协议》</a>和<a href="https://www.heartide.com/cosleep/help/doc#/privacy">《隐私政策》</a>的特别服务条款。请在接受使用会员订阅服务前务必审慎阅读、充分理解《服务协议》和《隐私政策》及本条款的相应内容，并选择接受或不接受。本条款未予以约定的，适用《服务协议》和《隐私政策》的约定；本条款与《服务协议》和《隐私政策》有冲突的，以本条款为准。
      </p>
    </div>
    <div class="block">
      <p class="two-title">一、会员订阅服务的内容</p>
      <p class="common-p">领取或经付费开启会员订阅服务后，您可以在相应服务期限内持续使用心潮专属会员服务，包括但不限于音频、功能和专属会员服务等等。</p>
      <p class="common-p">（一）1个月会员、3个月会员、6个月会员、12个月会员、24个月会员、36个月会员<br/>
        开启1个月会员、3个月会员、6个月会员、12个月会员、24个月会员、36个月会员后，你所获得的服务期限分别为31个自然日、93个自然日、186个自然日、372个自然日、744个自然日，1116个自然日。
      </p>
      <p class="common-p">（二）自动续费服务</p>
      <p class="common-p">1.	连续包月是在您已开启会员订阅服务的前提下，向您提供的自动续费服务。如您开通自动续费服务，则视为您授权心潮在您已开通的会员订阅服务即将到期时，从您的自有充值账户、与心潮帐号绑定的第三方支付账户、银行卡、通讯账号、iTunes账户（简称“账户”）等代扣下一个计费周期的月卡服务费用。扣费时间为计费周期到期前24小时内。</p>
      <p class="common-p">
        2.	您需要将心潮帐号与前述账户进行绑定，且保证有足够余额支持代扣。因上述账户余额不足导致续费失败的，您将自行承担相应结果。
      </p>
      <p class="common-p">
        3.	您可通过下述途径取消已开通的连续包月服务：
      </p>
      <p class="common-p">
        （一）苹果手机在 iOS设备“设置” → “iTunes Store 与 App Store” → 选择“Apple ID” → 点击“查看 Apple ID” → 在账户设置页面点击“订阅” → 取消订阅。如未在计费周期到期前至少24小时前取消自动续费功能，将会自动续订及扣款。
      </p>
      <p class="common-p">
          （二）小米&红米手机在“我的” → “会员” → 进入右上角“管理续费”页面，申请取消连续订阅项目。如未在计费周期到期前至少24小时前取消连续订阅功能，将会自动续订及扣款。
      </p>

      <p class="common-p">
        （三）自动续费服务与正常会员服务并存说明
      </p>
      <p class="common-p">
        当连续包月会员与正常会员服务出现并存情况时，则优先使用连续包月会员时长， 正常会员服务时长则在原服务有效期基础上延长。
      </p>
    </div>
    <div class="block">
      <p class="two-title">二、付费服务</p>
      <p class="common-p">
        （一）您理解并同意，会员订阅服务为付费服务，心潮将收取互联网增值服务使用费；您可以在相关服务页面查阅会员订阅服务具体期限及对应费用并自行选择服务的种类。开启会员订阅功能后，无论您是否在相应服务期限内实际使用该服务，已支付的费用不支持退款。
      </p>
      <p class="common-p">
        （二）您理解并同意，心潮科技有权自行决定并不时修订会员订阅服务相关的收费标准和规则，该类标准及规则一经发布即生效，并构成本条款的有效组成部分。如您不同意前述标准、规则及其修订，您有权停止使用会员订阅服务。您继续使用会员订阅服务即视为您同意相关内容。
      </p>
    </div>
    <div class="block">
      <p class="two-title">三、免责声明</p>
      <p class="common-p">心潮科技有权根据产品计划和运营情况独立决定会员订阅服务的具体内容，并有权根据内容的版权情况新增或移除内容或暂停、终止提供会员订阅服务的部分功能服务。前述决定不经通知即生效，您同意心潮科技对此免责。</p>
      <p class="common-p">如您对上述条款有任何疑问请发送电子邮件到office@heartide.com。</p>
    </div>
    <div class="block">
      <p class="two-title" style="text-align: right">广州心与潮信息科技有限公司</p>
      <p class="common-p" style="text-align: right">更新时间2018年12月7日</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'iosmember',
  mounted () {
    document.title = '会员订阅服务条款'
  }
}
</script>

<style lang="scss" scoped>
.iosmembe {
  font-size: px2html(14px);
  box-sizing: border-box;
  margin-top: px2html(20px);
  padding-left: px2html(21px);
  padding-right: px2html(21px);
  .title {
    font-size: px2html(16px);
    font-weight: 900;
    margin-bottom: px2html(28px);
  }
  .block {
    margin-bottom: px2html(28px);
  }
  .two-title {
    font-weight: 700;
    text-align: left;
    margin-bottom: px2html(14px);
  }
  .common-p {
    text-align: left;
    margin-bottom: 7px;
  }
}
</style>
